import styled from 'styled-components';

export const BodyContainer = styled.div`
  border-top: 1px solid #F3F4F5;
  padding: 5px 0px;
`;